<template>
  <app-layout class="menu-page-template">
    <p style="padding:15px">Organization Staff Invitations:</p>
    <Row type="flex" justify="center">
      <Col :span="24" style="padding:0 15px;color:#aaa" v-if="invitations.data.invites.length <= 0">
        No pending staff invitations.
      </Col>
      <Col :span="24" v-for="(item,k) in invitations.data.invites" :key="k">
          <Card shadow :style="{borderRadius: '0', borderTop: '1px solid #F2F2F2'}" :padding="15">
              <div class="truncate">
                  <div style="float:right;margin-top:3px">
                    <Button @click="decline(item)"><i class="fas fa-times"></i></Button>&nbsp;
                    <Button @click="accept(item)" type="primary"><i class="fas fa-check"></i></Button>
                  </div>
                  <Avatar :src="item.doctor.avatar" shape="square" size="large"></Avatar>
                  {{item.doctor.display_name}}
              </div>
          </Card>
      </Col>
    </Row>
    <p style="padding:15px" v-if="invitations.prescription">Group Invitations:</p>
    <Row type="flex" justify="center" v-if="invitations.prescription">
      <Col :span="24" style="padding:0 15px;color:#aaa" v-if="invitations.prescription.careplans.length <= 0">
        No pending group invitations.
      </Col>
      <Col v-if="invitations.prescription.careplans.length > 0" :span="24" v-for="(item,k) in invitations.prescription.careplans" :key="k">
          <Card shadow :style="{borderRadius: '0', borderTop: '1px solid #F2F2F2'}" :padding="15">
              <div class="truncate">
                  <div style="float:right;margin-top:3px">
                    <Button @click="decline(item)"><i class="fas fa-times"></i></Button>&nbsp;
                    <Button @click="accept(item)" type="primary"><i class="fas fa-check"></i></Button>
                  </div>
                  <Avatar :src="item.careplan.thumbnail_photo[0].small" shape="square" size="large"></Avatar>
                  {{item.careplan.title}}
              </div>
          </Card>
      </Col>
    </Row>
    <div v-if="confirmModal">
      <ModalHolder :mHeight="'5vh'" :title="'Confirm'" :is-show="confirmModal">
        <template slot="mheader">Confirm</template>
        <template slot="mcontent">
          {{txt}}
        </template>
        <template slot="mfooter">
          <Button type="default" @click="confirmModal = false">Close</Button>
          <Button type="error" v-if="!isAccept" @click="onSubmitDecline(itemSelected)">Decline</Button>
          <Button type="primary" v-else @click="onSubmitAccept(itemSelected)">Accept</Button>
        </template>
      </ModalHolder>
    </div>
  </app-layout>
</template>

<script>
import ModalHolder from '@/components/ModalHolderComponent'

export default {
  name: 'PendingInvitationsComponent',
  components: {
    ModalHolder
  },
  data () {
    return {
      confirmModal: false,
      itemSelected: {},
      txt: 'Are you sure ',
      isAccept: true
    }
  },
  computed: {
    invitations: {
      get () { return this.$store.state.user.invitations }
    }
  },
  methods: {
    accept (item) {
      this.confirmModal = true
      this.isAccept = true
      this.itemSelected = item
      var lbl = ('careplan' in item) ? item.careplan.title : item.doctor.display_name
      this.txt = 'Are you sure you want to accept: ' + lbl + '?'
    },
    decline (item) {
      this.confirmModal = true
      this.isAccept = false
      this.itemSelected = item
      var lbl = ('careplan' in item) ? item.careplan.title : item.doctor.display_name
      this.txt = 'Are you sure you want to decline: ' + lbl + '?'
    },
    clear () {
      this.confirmModal = false
      this.isAccept = false
      this.itemSelected = {}
    },
    removeItem (item) {
      this.clear()
      for (var x = 0; x < this.invitations.data.invites.length; x++) {
        if (item.id === this.invitations.data.invites[x].id) {
          this.invitations.data.invites.splice(x, 1)
          break
        }
      }
    },
    onSubmitDecline (item) {
      if ('careplan' in item) {
        this.$store.dispatch('user/declinePrescription', {item}).then(res => {
          this.clear()
        })
      } else {
        this.$store.dispatch('user/declineInvitation', {item}).then(res => {
          this.removeItem(res)
        })
      }
    },
    onSubmitAccept (item) {
      if ('careplan' in item) {
        this.$store.dispatch('user/acceptPrescription', {item}).then(res => {
          this.clear()
        })
      } else {
        this.$store.dispatch('user/acceptInvitation', {item}).then(res => {
          this.removeItem(res)
        })
      }
    }
  }
}
</script>
